import _ from "lodash"
import defaultMessages from "../../i18n/default.messages"

let messages = {
    messages: {
        'es-MX': {
            moduleTitle: 'Usuarios',
            tblTitle: 'Administrar usuarios',
            tblbutton: 'Agregar',
            mdlSave: 'Guardar',
            mdlCancel: 'Cancelar',
            lblUsername: 'Usuario',
            lblEmail: 'Email',
            lblRole: 'Rol',
            dlgAddTitle: 'Agregar usuario',
            dlgUploadTitle: 'Editar privilegios',
            lblback: 'Atras',
            errorDuplicate: 'Usuario duplicado',
            errorUserNotFound: 'El usuario no existe',


            headerUsername: 'Usuario',
            headerName: 'Nombre',
            headerMail: 'E-mail',
            headerRole: 'Rol',
            headerAction: 'Acciones',

            lblSearch: 'Buscar',
            lblEdit: 'Editar',
            lblDelete: 'Eliminar atributo',

            lblEdit2: 'Los Atributos de tipo Tiene/No tiene no pueden ser actualizados',
            lbldelete1: 'Estás apunto de eliminar el usuario',
            lbldelete2: 'Estas Seguro?',

        },
        en: {
            moduleTitle: 'Users',
            tblTitle: 'Manage users',
            tblbutton: 'Add',
            mdlSave: 'Save',
            mdlCancel: 'Cancel',
            lblUsername: 'Username',
            lblEmail: 'Email',
            lblRole: 'Role',
            dlgAddTitle: 'Add user',
            dlgUploadTitle: 'Update permissions',
            lblback: 'Go back',
            errorDuplicate: 'The user already exist',
            errorUserNotFound: 'User not found',

            headerUsername: 'Username',
            headerName: 'Name',
            headerMail: 'E-mail',
            headerRole: 'Role',
            headerAction: 'Actions',

            lblSearch: 'Search',
            lblEdit: 'Edit',
            lblDelete: 'Delete attribute',

            lblEdit2: 'Attributes of type Has / Does not have cannot be updated',
            lbldelete1: 'You are about to remove the user',
            lbldelete2: 'Are you sure?',



        }
    }
}

export default _.merge(messages, defaultMessages)